// Core packages
import { HttpClient } from "@angular/common/http";
// Third party packages
import { EMPTY, Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ConfigService } from "./config.service";
import * as i0 from "@angular/core";
import * as i1 from "./config.service";
import * as i2 from "@angular/common/http";
var GoogleapiService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function GoogleapiService(configService, http) {
        this.configService = configService;
        this.http = http;
    }
    /**
    * Get Google Geocoding by address
    *
    * @param address Address
    *
    * @returns object|null The geocoding data found or null
    */
    GoogleapiService.prototype.getGeocoding = function (address) {
        var _this = this;
        try {
            return new Observable(function (obs) {
                var textAddress = address.route + "+" + address.streetNumber + "+" + address.postalCode + "+" + address.city;
                textAddress = encodeURIComponent(textAddress);
                var url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + textAddress + "&key=" + _this.configService.googleMapsApi;
                _this.http
                    .get(url)
                    .pipe(catchError(_this.handleError))
                    .subscribe(function (res) {
                    if (res &&
                        res.status === "OK") {
                        obs.next(res.results);
                    }
                    else {
                        obs.next();
                    }
                }, function (error) {
                    console.warn(error);
                    return obs.error(error);
                }, function () {
                    return obs.complete();
                });
            });
        }
        catch (error) {
            console.warn(error);
            return EMPTY;
        }
    };
    /**
     * Handle http errors
     *
     * @since 1.0.0
     */
    GoogleapiService.prototype.handleError = function (error) {
        // const message = error.error.message;
        // if (typeof context.toastrService !== 'undefined') {
        //   context.toastrService.error(message);
        // }
        if (error.status === 0) {
            return of(new Error("Unexpected error. Please reload the page and try again"));
        }
        return throwError(error);
    };
    GoogleapiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GoogleapiService_Factory() { return new GoogleapiService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.HttpClient)); }, token: GoogleapiService, providedIn: "root" });
    return GoogleapiService;
}());
export { GoogleapiService };
